class Form {
    constructor() {

    }

    serialize(form) {
        function stringKey(key, value) {
            var beginBracket = key.lastIndexOf('[');

            if (beginBracket === -1) {
                var _hash = {};
                _hash[key] = value;
                return _hash;
            }

            var newKey = key.substr(0, beginBracket);
            var newValue = {};

            newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

            return stringKey(newKey, newValue);
        }

        var hash = {};

        for (var i = 0, len = form.elements.length; i < len; i++) {
            var formElement = form.elements[i];

            if (formElement.name === '' || formElement.disabled) {
                continue;
            }

            if (formElement.name && !formElement.disabled && (formElement.checked || /select|textarea/i.test(formElement.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(formElement.type))) {
                var stringKeys = stringKey(formElement.name, formElement.value);
                hash = this.extend(hash, stringKeys);
            }
        }

        return hash;
    }
    extend() {
        var extended = {};
        var i = 0;

        // Merge the object into the extended object
        var merge = function merge(obj) {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    // If property is an object, merge properties
                    if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
                        extended[prop] = Form.extend(extended[prop], obj[prop]);
                    } else {
                        extended[prop] = obj[prop];
                    }
                }
            }
        };

        // Loop through each object and conduct a merge
        for (; i < arguments.length; i++) {
            merge(arguments[i]);
        }

        return extended;
    }

}

class Drawer {
    constructor(element) {
        var options =
            arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.element = element;
        this.delegateElement = new Delegate(this.element);
        this.delegateBody = new Delegate(document.body);
        this.pageOverlayElement = document.querySelector(".pageOverlay");

        if (navigator.platform === "iPhone")
            document.documentElement.style.setProperty(
                "--viewport-height",
                `${window.innerHeight}px`
            );
        this.onOpen = options["onOpen"] || function() {};
        this.onClose = options["onClose"] || function() {};

        this.isOpen = false;
        this.bindEvents();
    }

    bindEvents() {
        this.delegateBody.on(
            "click",
            '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',

            this.openDrawer.bind(this)

        );
        this.delegateBody.on(
            "click",
            '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
            this.closeDrawer.bind(this)
        );
        this.delegateBody.on(
            "click",
            '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
            this.toggleDrawer.bind(this)
        );
        this._openListener = this.openDrawer.bind(this);
        this._closeListener = this.closeDrawer.bind(this);

        document.addEventListener('cart-drawer:open', this.closeDrawer.bind(this));
    }

    toggleDrawer() {
        event.preventDefault();
        this.isOpen ? this.closeDrawer() : this.openDrawer();
    }

    openDrawer() {
     
        if (this.isOpen) {
            this.closeDrawer();
            return;
        }
        
        this.element.dispatchEvent(new CustomEvent('favorite-product:open', {
            bubbles: true
        }));

        this.element.setAttribute("aria-expanded", "true");
        this.pageOverlayElement.classList.add("is-visible");
        this.pageOverlayElement.classList.add("is-fav");
        $("html").addClass("is-locked");
        document.body.style.overflow = "hidden";
        this.pageOverlayElement.addEventListener("click", this._closeListener);
        this.isOpen = true;
        trapFocus(this.element);
        this.onOpen(); // Call the callback to allow other code to hook their logic

        return false;
    }

    closeDrawer(event) {
        if (!this.isOpen) {
            return;
        }
        if (event) {
            event.preventDefault();
        }

        this.element.dispatchEvent(new CustomEvent('favorite-product:close', {
            bubbles: true
        }));

        document.body.style.overflow = "auto";
        this.element.setAttribute("aria-expanded", "false");
        this.pageOverlayElement.classList.remove("is-visible");
        this.pageOverlayElement.classList.remove("is-fav");
        $("html").removeClass("is-locked");
        this.pageOverlayElement.removeEventListener("click", this._closeListener);
        removeTrapFocus(this.element);
        this.closeAnimation(this.element);
        this.isOpen = false;

        this.onClose();

        this.onClose();
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest("details");
        this.closeSubmenu(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute("open");
                if (detailsElement.closest("details[open]")) {
                    trapFocus(
                        detailsElement.closest("details[open]"),
                        detailsElement.querySelector("summary")
                    );
                }
            }
        };

        window.requestAnimationFrame(handleAnimation);
    }
}


class FavoritesDrawer extends HTMLElement {
    constructor() {
        super();
        this.element = this;        
        
        this.sidebarDrawer = new Drawer(this.element);
        this.delegateElement = new Delegate(this.element);
        this.delegateBody = new Delegate(document.body);
        this.pageOverlayElement = document.querySelector(".pageOverlay");
        this._attachListeners();
        this.onUnload();
        this._toggleFavorites();
    }

    onUnload() {
        this.delegateElement.off();
        document.removeEventListener('product:added', this._onFavoritesCloseListener);
       
       this.element.removeEventListener('click', this._addToFavoritesL);
        document.removeEventListener('favorite-product:rerender', this.onRerender);
        document.removeEventListener('favorite-product:open', this._onFavoritesCloseListener);
        
    }

    _attachListeners() {

        this.delegateElement.on('change', '.selectbox', this._onOptionChanged.bind(this));
      
        this._onFavoritesCloseListener = this.close.bind(this);
        this.onRerender = this._rerenderFavorites.bind(this);

        this.delegateElement.on('click', '[data-action="remove-favorites"]', this._removeFromDrawer.bind(this));

        this.delegateElement.on('click', '[data-action="addall-to-cart"]', this._addAllToCart.bind(this));
        this.delegateElement.on('submit', 'form[action="/cart/add"]', this._addToCart.bind(this));

        document.addEventListener('favorite-product:rerender', this.onRerender);

        if(!document.body.classList.contains('listener')){
            this._onFavoritesOpenListener = this._onFavoritesOpen.bind(this);
            this._addToFavoritesL =  this._addToFavorites.bind(this);
            this.delegateBody.on('click', '[data-action="toggle-favorites"]', this._addToFavoritesL);
            document.body.classList.add('listener');
            document.addEventListener('favorite-product:open', this._onFavoritesOpenListener);
         
          }

    }

    _onFavoritesOpen() {
    
        var _this = this;
        this._rerenderFavorites();
        this.sidebarDrawer.isOpen = true;
      
        this.sidebarDrawer.openDrawer();
        
    }

    _addToFavorites(event) {
        event.preventDefault();
        event.stopPropagation();

        var items = JSON.parse(localStorage.getItem('productFavorites') || '[]');
        var $this = $(event.target);
        var iconUnfilled = event.target.parentElement.querySelector(".Icon--favorites");
        var iconFilled = event.target.parentElement.querySelector(".Icon--favorites-filled");
        var productId = event.target.getAttribute('data-id');
        // We check if the current product already exists, and if it does not, we add it at the start
        if (!items.includes(productId) && productId != "") {
            items.unshift(productId);

            iconUnfilled.style.display = "none";
            iconFilled.style.display = "inline-block";

        } else {

            this._removeFromFavorites(productId, false);
            iconUnfilled.style.display = "inline-block";
            iconFilled.style.display = "none";
            return;
        }

        // Then, we save the current product into the local storage, by keeping only the 50 most recent
        try {
            localStorage.setItem('productFavorites', JSON.stringify(items.slice(0, 50)));
            this._toggleFavorites();
            this.sidebarDrawer.openDrawer();
            this._rerenderFavorites();
           

        } catch (error) {
            // Do nothing, this may happen in Safari in incognito mode
        }


    }

    _removeFromFavorites(productId) {
        var items = JSON.parse(localStorage.getItem('productFavorites') || '[]');

        items = items.filter(c => c != productId);

        try {
            localStorage.setItem('productFavorites', JSON.stringify(items.slice(0, 50)));
            this._toggleFavorites();
            
            this._rerenderFavorites();

        } catch (error) {
            console.log(error)
        }

    }
    
    _toggleFavorites() {

        var items = JSON.parse(localStorage.getItem('productFavorites') || '[]');

        $('.ProductItem__Favorites').each(function(index) {

            let $this = $(this);
            let myID = $this.attr('data-id');
            if (items.includes(myID)) {
                $(".Icon--favorites-filled", $this).show();
                $(".Icon--favorites", $this).hide();
                if ($(".favorites--add", $this)) {
                    $(".favorites--add", $this).hide();
                    $(".favorites--added", $this).show();

                }
            } else {
                $(".Icon--favorites-filled", $this).hide();
                $(".Icon--favorites", $this).show();
                if ($(".favorites--add", $this)) {
                    $(".favorites--add", $this).show();
                    $(".favorites--added", $this).hide();

                }
            }

        });

    }

    close(event) {
        this._updateAddToCartButton_all();
        this.sidebarDrawer.closeDrawer();

    }

    _removeFromDrawer() {

        var items = JSON.parse(localStorage.getItem('productFavorites') || '[]');
        var productId = event.target.getAttribute('data-id');
        items = items.filter(c => c != productId);

        try {
            localStorage.setItem('productFavorites', JSON.stringify(items.slice(0, 50)));
            const $container = $('#favorites');
            $(".Cart.Drawer__Content").html(' ');

            this._rerenderFavorites();
        } catch (error) {
            console.log(error)
        }
    }

    _updateAddToCartButton_all(newVariant, id) {

        var discount = window.theme.discount / 100;

        var addToCartButton = this.element.querySelector('.money-all'),
            newButton = document.createElement('span');

        var form = this.element.querySelector('#AddToCartAll');
        var checkExist = document.querySelector("#input--" + id);

        if (newVariant) {
            if (newVariant['available']) {

                let el = document.createElement('input');
                el.setAttribute("id", "input--" + id);
                el.setAttribute("data-id", id);
                el.setAttribute("type", "hidden");
                el.setAttribute("name", "id_" + newVariant.id);
                el.setAttribute("data-price", newVariant.price);
                el.setAttribute("value", newVariant.id);
                if (checkExist) {

                    form.replaceChild(el, checkExist);
                    var oldPrice = checkExist.getAttribute('data-price');
                    //  var amount = parseInt(addToCartButton.getAttribute('data-money'));
                    var quantitySel = document.querySelector('#quantity--id_' + id);
                    var currQuantity = 1;

                    if (quantitySel) {
                        currQuantity = parseInt(quantitySel.value);

                    }




                } else {
                    form.prepend(el);
                    //    var amount = parseInt(addToCartButton.getAttribute('data-money'));
                    var quantitySel = document.querySelector('#quantity--id_' + id);
                    var currQuantity = 1;
                    if (quantitySel) {
                        currQuantity = parseInt(quantitySel.value);

                    }
                    var newPrice = parseInt(newVariant['price']) + amount;
                    if (discount > 0) {
                        newPrice = newPrice - (newPrice * discount);
                    }

                    newButton.setAttribute("data-money", newPrice);
                    newButton.className = 'money-all';
                    newButton.innerHTML = '\n<span data-money-convertible>' + theme.Shopify.formatMoney(
                        newPrice,
                        theme.money_format
                    ) + '</span>\n          ';



                }

                addToCartButton.parentNode.replaceChild(newButton, addToCartButton);
            } else {


            }
        }

    }

    _onOptionChanged(newValue, target, activator) {
        var targetID = target.getAttribute('data-id');
        var jsonData = JSON.parse(this.element.querySelector('[data-product-json-' + targetID + ']').innerHTML);
        this.productData = jsonData['product'];
        this.variantsInventories = jsonData['inventories'] || {};
        this.masterSelector = this.element.querySelector('#product-select-' + this.productData['id']);


        this.productData = jsonData['product'];
        this.variantsInventories = jsonData['inventories'] || {};
        this.masterSelector = this.element.querySelector('#product-select-' + this.productData['id']);

        var _this5 = this;

        // We init value with the first selected variant
        this.productData['variants'].forEach(function(variant) {

            if (variant['id'] === jsonData['selected_variant_id']) {
                _this5.currentVariant = variant;
                _this5.option1 = variant['option1'];
                _this5.option2 = variant['option2'];
                _this5.option3 = variant['option3'];
            }
        });
        // We change the value associated with the activator, and check if we have a color swatch

        if (activator) {
            this['option' + target.getAttribute('data-option-position')] = newValue;
            activator.querySelector('.ProductForm__SelectedValue').innerHTML = newValue;
        } else {
            this['option' + target.getAttribute('data-option-position')] = target.value;
            var selectedValue = target.closest('option[checked="checked"]');


        }

        // Finally, we get the new variant
        var previousVariant = this.currentVariant;
        this.currentVariant = this._getCurrentVariantFromOptions();

        this._onVariantChanged(previousVariant, this.currentVariant, targetID);

        if (this.currentVariant) {


            // We need to modify the hidden select that contain the id attribute as well
            this.masterSelector.querySelector('[selected]').removeAttribute('selected');
            this.masterSelector.querySelector('[value="' + this.currentVariant['id'] + '"]').setAttribute('selected', 'selected');
        }
    }

    _getCurrentVariantFromOptions() {
        var _this7 = this;

        var found = false;

        this.productData['variants'].forEach(function(variant) {

            if (variant['option1'] === _this7.optionnull && variant['option2'] === _this7.option2 && variant['option3'] === _this7.option3) {
                found = variant;

            }
        });

        return found || null;
    }

    _rerenderFavorites(event, elementToAnimate) {

        var _this32 = this;
        var queryStrings = this._getSearchQueryStrings();
        const promises = [];

        queryStrings.forEach(string => {

            promises.push(
                fetch('/search?view=favorites&type=product&q=' + string, {
                    credentials: 'same-origin',
                    method: 'GET'
                }))

        })

        const el = $(_this32.element).find('#favorites');
        //     el.text("");

        if (!promises.length) {
            $('favorites-drawer').addClass('drawer-is-empty');
            $('#sidebar-favorites .Drawer__Main').html('<p class="Cart__Empty Heading u-h5">Du har inte lagt till några favoriter ännu</p>');
        } else {


            $('favorites-drawer').removeClass('drawer-is-empty');
        }
        promises.reduce(async (acc, val, index) => {

            let content = await val.then(response => response.text());
            const container = $(_this32.element).find('#favorites');

            content = content.replaceAll('favorites-drawer', 'div');
            

            if (!container.length) {
                _this32._replaceContent(content);

                var stringToHTML = function(str) {
                    var parser = new DOMParser();


                    var doc = parser.parseFromString(str, 'text/html');
                    return doc.body;
                };
                $("favorites-drawer .size-header .close__drawer,favorites-drawer li.colour-header.desxtop .close__drawer").click(function() {
                    let df = $(this);
                    df.parent().removeClass("active");

                    df.parent().next().slideUp();
                    $(".over_layy").fadeOut();
                });
                $("favorites-drawer .size-header .open__drawer,favorites-drawer li.colour-header.desxtop .open__drawer").click(function() {
                    let df = $(this);
                        let   _parent = df.parents("form");
                    df.parent().addClass("active");
                    $(".over_layy").fadeIn();
                    df.parent().next().slideDown();
                    if ($(window).width() < 749) {
                        $(".over_layy").click(function() {
                            $(".over_layy").fadeOut();
                            df.parent().removeClass("active");
                            df.parent().next().slideUp();
                        });
                        $(".closed_h3").click(function() {
                            $(this).hide();
                            $(this).parent().find(".opned_h3").show();
                            $(this).parent().find("div").slideUp();
                        });
                        $(".opned_h3").click(function() {
                            $(this).hide();
                            $(this).parent().find(".closed_h3").show();
                            $(this).parent().find(".closed_h3").addClass("active_size_guide");
                            $(this).parent().find("div").slideDown();
                        });
                          _parent.find(".all-variatns  option").each(function(){
    let _this = $(this),
        val = _this.data("variant-available"),
        title = _this.data("title")
      _parent.find(".Select-size input").each(function(){
      let _thisInput = $(this),
          valInput = _thisInput.data("title");
        if(valInput == title){
        _thisInput.parent("li").addClass(val);
        }
      });

    });
                    }
                });
                $("favorites-drawer .Select-size input").click(function() {

                    $(".over_layy").fadeOut();
                    let _this = $(this),
                        _parent = _this.parents("form");
                    let title2 = $(this).data("title");
                    $(this).parents(".variants-items").find(".size-header span:not(.open__drawer--d)").text(title2);
                    $(this).parents(".variants-items").find(".Select-size").slideUp();

                    var meta_specification = $(this).parents(".variants-items").find(".size_guide div");
                 

 _this.parents(".variants-items").find(".size-header").removeClass("active");

                    _parent.find(".all-variatns option").each(function() {
                        let _this2 = $(this),
                            title = _this2.data("title"),
                            av = _this2.data("variant-available");
                        if (title2 == title) {
                            _this2.attr("selected", "selected").siblings().removeAttr("selected", "selected");
                            if (av == "not-available") {
                                _parent.find(".variants--val").html("<span class='not-available'>Variant is not available!</span>");
                                setTimeout(function() {
                                    $(".not-available").remove();
                                }, 1500)
                            }
                        }

                    })



                });




                $(".FavoritesItem--AddToCart").click(function() {
                  document.body.style.overflow = "auto";
                    document.querySelector("favorites-drawer").setAttribute("aria-expanded", "false");
                    let _this = $(this),
                        _parent = _this.parents(".FavoritesItem--Wrapper");
                    if (_parent.find('ul.variants-items div input:checked').length == 0) {
                        _parent.find("ul.variants-items .Select-size").show();
                        _parent.find("ul.variants-items").addClass("activeOverlay");
                        $("body").addClass("activeBody");

                        _parent.find(".activeOverlay input").click(function() {
                            _parent.find("ul.variants-items").removeClass("activeOverlay");
                            $("body").removeClass("activeBody");
                            _parent.find("li.size-header span:nth-child(3)").text($(this).data("title"));


                            var selectedOptions = '';
                            _parent.find('ul.variants-items div input:checked').each(function(i) {
                                if (selectedOptions == '') {
                                    selectedOptions = $(this).data("title");
                                } else {
                                    selectedOptions = selectedOptions + ' / ' + $(this).data("title");
                                }
                            });
                            _parent.find(".all-variatns option").each(function() {
                                let _this = $(this),
                                    title = _this.data("title");
                                if (title == selectedOptions) {
                                    _this.attr("selected", "selected").siblings().removeAttr("selected", "selected");
                                }
                            })



                        });
                    } else {

                        addToCarst(_parent.find(".all-variatns option:selected").data("id"), _parent.find(".colour-header.desxtop   span").text());

                    }
                });


                $(".add_all--favz").click(function() {
                    let _this = $(this),
                        _parent = _this.parents("favorites-drawer");
                    var array = [];
                    $("favorites-drawer .all-variatns").each(function() {
                        let _this = $(this),
                            _option = _this.find("option:selected").data("id");

                        let d = _this.parents("form"),
                            Colour = d.find(".colour-header span:nth-child(2)").text();

                        let object = {
                            'id': _option,
                            'properties': {
                                'Colour': Colour
                            }
                        };
                        array.push(object);
                    });
                    document.body.style.overflow = "auto";
                    document.querySelector("favorites-drawer").setAttribute("aria-expanded", "false");

                  addToCarst_multi(array);




                });




                $(".header--var").click(function() {
                    $(this).parent().slideUp();
                    $(".over_layy").fadeOut();
                    $(this).parents("ul").find("li:first-child").removeClass("active");
                });
            } else {
                const containerContent = $(content).find('#favorites').html();



                container.append(containerContent);
                _this32._updateAddToCartButton_all();

            }




        }, Promise.resolve());

        _this32._updateAddToCartButton_all();



        return Promise.resolve();
    }

    _onProductAdded(event) {
        var _this31 = this;

        this._rerenderFavorites().then(function() {


            _this31._updateAddToCartButton_all();


        });
        this.isOpen = true;

    }

    _addAllToCart(event) {
        //     event.preventDefault();
        //     var _this8 = this;

        //     event.preventDefault(); // Prevent form to be submitted

        //     var addToCartButton = this.element.querySelector('.add_all--favz');

        //     // First, we switch the status of the button
        //     addToCartButton.setAttribute('disabled', 'disabled');
        //     document.dispatchEvent(new CustomEvent('theme:loading:start'));

        //     // Then we add the product in Ajax
        //     var formElement = this.element.querySelector('form[action^="/cart/addall"]');
        //     var formHelper = new Form();
        //     var formElementSerialized = formHelper.serialize(formElement);

        //     const items = []
        //     const keys = Object.keys(formElementSerialized)

        //     var quant = 1;
        //     keys.forEach(key => {
        //       let productID = formElement.querySelector('[name="' + key + '"]').getAttribute('data-id');

        //       if (productID) {
        //         quant = formElement.querySelector("#quantity--id_" + productID);
        //         if (quant) {
        //           quant = quant.getAttribute('value');
        //         }

        //       }

        //       items.push({
        //         id: formElementSerialized[key],
        //         quantity: quant
        //       })
        //     })


        //     fetch('/cart/add.js', {
        //       body: JSON.stringify({
        //         items: items
        //       }),
        //       credentials: 'same-origin',
        //       method: 'POST',
        //       headers: {
        //         'Content-Type': 'application/json',
        //         'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        //       }
        //     }).then(function(response) {
        //       document.dispatchEvent(new CustomEvent('theme:loading:end'));
        //       if (response.ok) {
        //         addToCartButton.removeAttribute('disabled');
        //         // We simply trigger an event so the mini-cart can re-render
        //         _this8.element.dispatchEvent(new CustomEvent('product:added', {
        //           bubbles: true,
        //           detail: {
        //             variant: _this8.currentVariant,
        //             quantity: keys.length
        //           }
        //         }));
        //         window.location.href = "/cart";

        //       } else {
        //         response.json().then(function(content) {
        //           var errorMessageElement = document.createElement('span');
        //           errorMessageElement.className = 'ProductForm__Error-all Alert Alert--error';
        //           errorMessageElement.innerHTML = content['description'];
        //           addToCartButton.removeAttribute('disabled');
        //           addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
        //           setTimeout(function() {
        //          errorMessageElement.remove();
        //           }, 2500);
        //         });
        //       }
        //     });

        event.preventDefault();
    }

    _addToCart(event) {

        var _this8 = this;

        event.preventDefault(); // Prevent form to be submitted

        console.log(_this8);

        //     var addToCartButton = event.target.querySelector('.FavoritesItem--AddToCart');

        //     // First, we switch the status of the button
        //     addToCartButton.setAttribute('disabled', 'disabled');
        //     document.dispatchEvent(new CustomEvent('theme:loading:start'));

        //     // Then we add the product in Ajax
        //     var formElement = event.target;
        // var formHelper = new Form();
        //     var formElementSerialized =formHelper.serialize(formElement);


        //     fetch('/cart/add.js', {
        //       body: JSON.stringify(formElementSerialized),
        //       credentials: 'same-origin',
        //       method: 'POST',
        //       headers: {
        //         'Content-Type': 'application/json',
        //         'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        //       }
        //     }).then(function(response) {
        //       document.dispatchEvent(new CustomEvent('theme:loading:end'));
        //       if (response.ok) {
        //       //  addToCartButton.removeAttribute('disabled');
        //         // We simply trigger an event so the mini-cart can re-render


        //         addToCartButton.removeAttribute('disabled');
        //         addToCartButton.innerHTML = theme.strings.productFormAdded;

        //       } else {
        //         response.json().then(function(content) {
        //           var errorMessageElement = document.createElement('span');
        //           errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
        //           errorMessageElement.innerHTML = content['description'];

        //           addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
        //           setTimeout(function() {
        //            errorMessageElement.remove();
        //           }, 2500);
        //         });
        //       }
        //     });

        event.preventDefault();
    }

    _updateProductPrices(newVariant, previousVariant) {

        var productMetaPrices = event.target.closest('.FavoritesItem--Meta').querySelector('.FavoritesItem--Price');
        var productMetaPricesDc = event.target.closest('.FavoritesItem--Meta').querySelector('.CartItem__OriginalPrice');

        var discount = window.theme.discount / 100;

        if (!newVariant) {
            productMetaPrices.style.display = 'none';
        } else {
            if (previousVariant && previousVariant['price'] === newVariant['price'] && previousVariant['compare_at_price'] === newVariant['compare_at_price']) {
                return; // The price do not have changed so let's return to avoid changing the DOM for nothing
            }

            productMetaPrices.innerHTML = '';
            if (productMetaPricesDc) {
                productMetaPricesDc.innerHTML = '';
            }

            if (newVariant['compare_at_price'] > newVariant['price']) {
                productMetaPrices.innerHTML += '<span class="ProductMeta__Price Price Heading u-h4" data-money-convertible>' + theme.Shopify.formatMoney(
                    newVariant['price'],
                    theme.money_format
                ) + '</span>';
                productMetaPricesDc.innerHTML += '<span class="CartItem__OriginalPrice Price Price--compareAt Heading" data-money-convertible>' + theme.Shopify.formatMoney(
                    newVariant['compare_at_price'],
                    theme.money_format
                ) + '</span>';
            } else if (discount > 0) {
                var dc_price = newVariant['price'] - (newVariant['price'] * discount);

                productMetaPrices.innerHTML += '<span class="ProductMeta__Price Price Heading u-h4" data-money-convertible>' + theme.Shopify.formatMoney(
                    dc_price,
                    theme.money_format
                ) + '</span>';
                productMetaPricesDc.innerHTML += '<span class="CartItem__OriginalPrice Price Price--compareAt Heading" data-money-convertible>' + theme.Shopify.formatMoney(
                    newVariant['price'],
                    theme.money_format
                ) + '</span>';

            } else {
                productMetaPrices.innerHTML += '<span class="ProductMeta__Price Price Heading u-h4" data-money-convertible>' + theme.Shopify.formatMoney(
                    newVariant['price'],
                    theme.money_format
                ) + '</span>';
            }

            productMetaPrices.style.display = '';
            if (productMetaPricesDc) {
                productMetaPricesDc.style.display = '';
            }
        }
    }

    _updateAddToCartButton(newVariant, previous, id) {


        var addToCartButton = this.element.querySelector('.ProductForm__AddToCart--' + id),
            newButton = document.createElement('button');

        newButton.setAttribute('type', 'submit');
        newButton.className = 'FavoritesItem--AddToCart ProductForm__AddToCart--' + id;

        if (!newVariant) {
            newButton.setAttribute('disabled', 'disabled');
            newButton.removeAttribute('data-action');

            newButton.innerHTML = theme.strings.productFormUnavailable;
        } else {
            if (newVariant['available']) {
                newButton.removeAttribute('disabled');
                newButton.setAttribute('data-action', 'add-to-cart');


                newButton.innerHTML = '<span class="u-b2 Link">' + theme.strings.productFormAddToCart + '</span>';

            } else {
                newButton.setAttribute('disabled', 'disabled');

                newButton.removeAttribute('data-action');
                newButton.innerHTML = theme.strings.productFormSoldOut;
            }
        }


        // We replace the HTML instead of editing as it prevents for the CSS transition to show up
        addToCartButton.parentNode.replaceChild(newButton, addToCartButton);
    }

    _replaceContent(html) {
        var tempElement = document.createElement('div');
        tempElement.innerHTML = html;
        var divCart = document.createElement('div');
        divCart.classList.add('Cart');

        // Convert in background
        this.element.appendChild(divCart);
        var cartNodeParent = this.element;


        cartNodeParent.replaceChild(tempElement.querySelector('.Cart'), this.element.querySelector('.Cart'));

        document.dispatchEvent(new CustomEvent('favorite-product:rendered'));

        return true;
    }

    _getSearchQueryStrings() {
        var items = JSON.parse(localStorage.getItem('productFavorites') || '[]');

        const bucketSize = 10.0;
        const idBuckets = [];
        items.forEach((id, index) => {
            const key = Math.floor(index / bucketSize);
            if (!idBuckets[key]) {
                idBuckets[key] = [];
            }
            idBuckets[key].push(id);
        });
        return idBuckets.reduce((acc, vall) => {
            const string = vall.map(function(id) {
                return 'id:' + id;
            }).join(' OR ');

            acc.push(string);

            return acc;
        }, []);
    }
    _onVariantChanged(previousVariant, newVariant, id) {
        // 1st: the prices
        this._updateProductPrices(newVariant, previousVariant);

        this._updateAddToCartButton_all(newVariant, id);
        // 4th: the add to cart button
        this._updateAddToCartButton(newVariant, previousVariant, id);


        // Finally, we send an event so that other system could hook and do their own logic
        this.element.dispatchEvent(new CustomEvent('variant:changed', {
            bubbles: true,
            detail: {
                variant: newVariant,
                previousVariant: previousVariant
            }
        }));
    }



}

customElements.define("favorites-drawer", FavoritesDrawer);

class AccountHandler extends HTMLElement {
    constructor() {
      super();
      this.element = this;
      this.delegateElement = new Delegate(this.element);
  
      this.drawer = new Drawer(this.element.querySelector('#accountDrawer'));
   this.bindEvents();
  
    }
    bindEvents(){
  
      this.delegateElement.on('click', '[data-action="toggle-tab"]', this.toggleTab.bind(this));
      this.delegateElement.on('click', '[data-action="submit-login"]', this.submitLogin.bind(this));
      this.delegateElement.on('click', '[data-action="submit-register"]', this.submitRegistration.bind(this));
  
      this.delegateElement.on('click', '[data-action="toggle-recovery"]', this.toggleRecovery.bind(this));
      this.delegateElement.on('click', '[data-action="submit-recovery"]', this.accountRecover.bind(this));
  }
  
  toggleRecovery(){
    event.preventDefault();
    const id = event.target.dataset.id;
  
    if (id == 'recoverFlex'){
      this.element.querySelector('#recoverFlex').setAttribute('aria-visible','true');
      this.element.querySelector('#loginFlex').setAttribute('aria-visible','false');
    }
     else{
      this.element.querySelector('#recoverFlex').setAttribute('aria-visible','false');
      this.element.querySelector('#loginFlex').setAttribute('aria-visible','true');
     }
  
     const inputRecovery = this.element.querySelector('#RecoverEmail');
      const _this = this;
  
     inputRecovery.addEventListener('keypress', function (event) {
      if(event.key === 'Enter'){
       event.preventDefault();
       _this.accountRecover(event);
      }
     })
     }
  
  accountRecover(event){
      event.preventDefault();
      const _this = this;
      const registrationEndpoint = '/account/recover';
  
      // Create the request body with the registration data
      const requestBody = {
          'email': this.element.querySelector('#RecoverEmail').value
      };
  
      _this.querySelector('.accountBtn--recovery .button--text').style.visibility = "hidden";
      //_this.querySelector('.accountBtn--recovery .itemLoader').classList.add('is-visible');
  
      // Send the AJAX request
      (async function() {
        try {
          const response = await fetch(registrationEndpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestBody)
          });
  
          const responseText = await response.text();
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = responseText;
        
          if (responseText.indexOf('RecoverEmail-email-error') !== -1) {
            console.log('nosucces')
            _this.element.querySelector('#recoverFlex .accountDrawer--ErrorSpace').innerHTML = tempDiv.querySelector('#RecoverEmail-email-error').innerHTML;
          } else if(responseText.indexOf('shopify-challenge__container') !== -1) {
            location.href = '/challenge';
  
        } else {
  
            let subtext = _this.element.querySelector('.recoverSubtext');
            let form = _this.element.querySelector('.recoveryForm');
            let message = _this.element.querySelector('.recoverMessage');
            subtext.style.display = 'none';
            form.style.display = 'none';
            message.style.display = 'block';

            _this.element.querySelector('#recoverFlex .accountDrawer--SuccessSpace').innerHTML = tempDiv.querySelector('#recoverSuccess').innerHTML;
          }
  
          _this.element.querySelector('.accountBtn--recovery .button--text').style.visibility = "visible";
         // _this.element.querySelector('.accountBtn--recovery .itemLoader').classList.remove('is-visible');
  
  
        } catch (error) {
          console.log('An error occurred during the registration request:', error);
        }
      })();
  }
  
  submitRegistration(event) {
  
    const _this = this;
    const registrationEndpoint = '/account';
  
    // Create the request body with the registration data
    const requestBody = {
      'customer': {
        'first_name': this.element.querySelector('#register #RegisterForm-FirstName').value,
        'last_name': this.element.querySelector('#register #RegisterForm-LastName').value,
        'email': this.element.querySelector('#register #RegisterForm-email').value,
        'password': this.element.querySelector('#register #RegisterForm-password').value
      }
    };
  
    /*event.target.querySelector('.ButtonText').style.visibility = "hidden";
    event.target.querySelector('.itemLoader').classList.add('is-visible');*/
  
    // Send the AJAX request
    (async function() {
      try {
        const response = await fetch(registrationEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        });
  
        const responseText = await response.text();
        console.log(responseText);
        if (responseText.indexOf('registerErrors') !== -1) {
          console.log('Error occurred during registration');
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = responseText;
  
          console.log(_this.element.querySelector('#register .accountDrawer--ErrorSpace'));
          console.log(tempDiv.querySelector('.registerErrors'));
          _this.element.querySelector('#register .accountDrawer--ErrorSpace').innerHTML = tempDiv.querySelector('.registerErrors').innerHTML;
        } else if(responseText.indexOf('shopify-challenge__container') !== -1) {
            location.href = '/challenge';
  
        }else {
          console.log(responseText);
          location.href = theme.routes.account_url;
        }
  
       /* event.target.querySelector('.ButtonText').style.visibility = "visible";
        event.target.querySelector('.itemLoader').classList.remove('is-visible');*/
  
  
      } catch (error) {
        console.log('An error occurred during the registration request:', error);
      }
    })();
  }
  
  
  submitLogin(event){
    event.preventDefault();
    const _this = this;
    const loginEndpoint = '/account/login';
  
    // Create the request body with the login credentials
    const requestBody = {
      'customer': {
        'email': this.element.querySelector('#customer_login #CustomerEmail').value,
        'password': this.element.querySelector('#customer_login #CustomerPassword').value
      }
    };
  
    /*event.target.querySelector('.ButtonText').style.visibility = "hidden";
    event.target.querySelector('.itemLoader').classList.add('is-visible');*/
  
    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(loginEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        });
  
  
          const responseText = await response.text();
  
          if (responseText.indexOf('loginError') !== -1) {
            console.log('Incorrect email or password');
            const tempDiv = document.createElement('div');
  
            tempDiv.innerHTML = responseText;
  
            _this.element.querySelector('#login .accountDrawer--ErrorSpace').innerHTML = tempDiv.querySelector('.AlertError').innerHTML;
          
            } else if(responseText.indexOf('shopify-challenge__container') !== -1) {
                location.href = '/challenge';
            } else {
            
            location.href = window.routes.account_url;
  
          }
  
  
  
      } catch (error) {
        console.log('An error occurred during the login request:', error);
      }
    })();
  
  }
  
  toggleTab(event) {
    const id = event.target.dataset.id;
    const allTabs = this.element.querySelectorAll('.accountDrawer--Tab[aria-expanded="true"]');
    const allContent = this.element.querySelectorAll('.accountContent');
  
    allTabs.forEach((tab) => {
      tab.setAttribute('aria-expanded', 'false');
    });
  
    event.target.setAttribute('aria-expanded', 'true');
  
    allContent.forEach((content) => {
      content.setAttribute('aria-visible', 'false');
    });
  
    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute('aria-visible', 'true');
    }
  }
  
  }
  
  customElements.define("account-handler", AccountHandler);

  Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options["method"] || "post";
    var params = options["parameters"] || {};
  
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
  
    for (var key in params) {
      var hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", key);
      hiddenField.setAttribute("value", params[key]);
      form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };

  class AccountComponent extends HTMLElement {
    constructor() {
      super();
      this.element = this;
      this.delegateElement = new Delegate(this.element);
      
      new Popup(this.element);
  
      this.accountHeader = this.element.querySelector('.customerAccount--Header');
    
      this.bindEvents();
      this.handleRefreshState();

      this.pageOverlayElement = document.querySelector(".pageOverlay_1");
      
    }
    bindEvents(){
      this.delegateElement.on(
        'click',
        '[data-action="handle-pagination"]',
        this.handlePagination.bind(this)
      );
      this.delegateElement.on(
        'click',
        '[data-action="toggle-subtab"]',
        this.toggleSubTab.bind(this)
      );
      this.delegateElement.on(
        'click',
        '[data-action="toggle-tab"]',
        this.toggleTab.bind(this)
      );
      this.delegateElement.on(
        'click',
        '[data-action="toggle-back"]',
        this.toggleBack.bind(this)
      );
      this.delegateElement.on(
        'click',
        '[data-action="delete-address"]',
        this.deleteAddress.bind(this)
      );

      this.delegateElement.on(
        "click",
        '[data-action="open-modal"]',
        this.openModal.bind(this)
    );
    this.delegateElement.on(
        "click",
        '[data-action="close-modal"]',
        this.closeModal.bind(this)
    );
    
    this.onClickOutsideListener = this.closeModal.bind(this);
  
  }

  openModal(){
    this.pageOverlayElement.classList.add("is-visible");
    this.pageOverlayElement.addEventListener("click", this.onClickOutsideListener);
  }

  closeModal(){
    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener("click", this.onClickOutsideListener);
    this.activeModal = document.body.querySelector('.Popup[aria-hidden="false"]');
    this.activeModal.setAttribute("aria-hidden", "true");
  }

  handlePagination(event, target){
      event.preventDefault();
      const contentContainer = this.element.querySelector('#activeOrders');
      const pagination = this.element.querySelector('#ordersPagination')
      
      
      if (event.target.tagName === 'A') {
        event.preventDefault();

        const desiredPage = event.target.getAttribute('href');
  
        fetch(window.routes.localeRootUrl + `${desiredPage}`)
        .then(response => response.text())
        .then(data => {
          const parseData = new DOMParser().parseFromString(data,'text/html');
         
           contentContainer.innerHTML = parseData.querySelector('#activeOrders').innerHTML; 
           pagination.innerHTML = parseData.querySelector('#ordersPagination').innerHTML;
        });
    
    
    }

  } 

  renderNewData(data){

  }

  handleRefreshState(){
    if (new Responsive().matchesBreakpoint('lap-and-up')) {
      this.element.querySelector('#contactInfo').setAttribute('aria-visible','true');
    }
        // Get the URL search parameters
        var searchParams = new URLSearchParams(window.location.search);

        // Get the value of param1
        var param1Value = searchParams.get('location');

        // Check if param1 has a value
        if (param1Value) {
          this.toggleTab(false, param1Value);
        }
  }
  
  deleteAddress(event) {
    event.preventDefault();
    const id = event.target.getAttribute("data-id");
  
    Shopify.postLink("/account/addresses/" + id, {
        parameters: { _method: "delete" },
    });
  }
  
  toggleBack(){
    const menuTab = this.element.querySelector('.customerAccount--Menu');
    menuTab.style.display = "flex";
    this.accountHeader.style.display = "block";
  
    const allContent = this.element.querySelectorAll('.customerAccount--Content');
    allContent.forEach((content) => {
      content.setAttribute('aria-visible', 'false');
    });
  }
  
  toggleTab(event, paramValue){
      let id = paramValue;
    if (event){
       id = event.target.dataset.id;
    }
   
    const allTabs = this.element.querySelectorAll('.customerAccount--MenuTab[aria-expanded="true"]');
    const allContent = this.element.querySelectorAll('.customerAccount--Content');
    const menuTab = this.element.querySelector('.customerAccount--Menu');
  

    // if (new Responsive().matchesBreakpoint('pocket')) {
    //   this.accountHeader.style.display = "none";
    //   menuTab.style.display = "none";
    // }


    allTabs.forEach((tab) => {
      tab.setAttribute('aria-expanded', 'false');
    });
    if (event){
      event.target.setAttribute('aria-expanded', 'true');
    } else {
      this.element.querySelector(`[data-id="${id}"]`).setAttribute('aria-expanded', 'true');
    }

  
    allContent.forEach((content) => {
      if (!content.classList.contains('customerAccount--ContentOrders')){
        content.setAttribute('aria-visible', 'false');
      }

    });
  
    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute('aria-visible', 'true');
    } 

 // Get the current URL
var currentUrl = window.location.href;

// Create a new URL with updated search parameters
var newUrl = currentUrl.split('?')[0] + `?location=${id}`;

// Modify the URL without refreshing the page
window.history.pushState({ path: newUrl }, '', newUrl);

  }

    
  toggleSubTab(event){
  
    const id = event.target.dataset.id;
    const allTabs = this.element.querySelectorAll('.customerAccount--toggleTab[aria-expanded="true"]');
    const allContent = this.element.querySelectorAll('.customerAccount--ContentOrders');

  
 
    allTabs.forEach((tab) => {
      tab.setAttribute('aria-expanded', 'false');
    });
  
    event.target.setAttribute('aria-expanded', 'true');
  
    allContent.forEach((content) => {
      content.setAttribute('aria-visible', 'false');
    });
  
    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute('aria-visible', 'true');
    } 
  }
  }
  
  
  customElements.define("account-component-inner", AccountComponent);

// class Favorites {
//     constructor(element) {
//         this.element = element;
//         if (!element) {
//             this.element = document;
//         }
//         this.delegateElement = new Delegate(this.element);
//         this.sidebarDrawer = new Drawer(this.element);
//         this.delegateBody = new Delegate(document.body);
//         this.onUnload();
//         this._attachListeners();
//         this._toggleFavorites();

//     }

//     onUnload() {
//         document.removeEventListener('favorite-product:open', this.onFavoritesOpenListener);
//         this.delegateElement.off();
//         this.element.removeEventListener('click', this._addToFavoritesL);
//         this.delegateElement.off('click', '[data-action="remove-favorites"]');
//     }


//     _attachListeners() {
//         this._addToFavoritesL = this._addToFavorites.bind(this);
//         this.delegateBody.on('click', '[data-action="toggle-favorites"]', this._addToFavoritesL);
//         this.onFavoritesOpenListener = this.onFavoritesOpen.bind(this);
//         document.body.classList.add('listener');
//         document.body.addEventListener('favorite-product:open', this.onFavoritesOpenListener);
//     }


//     onFavoritesOpen() {
//            console.log('test')
//             var _this = this;
//             this._rerenderFavorites().then(function () {
//             new AddToCart(_this.element);
//             });
//             this.sidebarDrawer.isOpen = true;
//       }

//     _addToFavorites(event) {
//         event.preventDefault();
//         event.stopPropagation();

//         var items = JSON.parse(localStorage.getItem('productFavorites') || '[]');
//         var $this = $(event.target);
//         var iconUnfilled = event.target.parentElement.querySelector(".Icon--favorites");
//         var iconFilled = event.target.parentElement.querySelector(".Icon--favorites-filled");
//         var productId = event.target.getAttribute('data-id');
//         // We check if the current product already exists, and if it does not, we add it at the start
//         if (!items.includes(productId) && productId != "") {
//             items.unshift(productId);

//             iconUnfilled.style.display = "none";
//             iconFilled.style.display = "inline-block";

//         } else {

//             this._removeFromFavorites(productId, false);
//             iconUnfilled.style.display = "inline-block";
//             iconFilled.style.display = "none";
//             return;
//         }

//         // Then, we save the current product into the local storage, by keeping only the 50 most recent
//         try {
//             localStorage.setItem('productFavorites', JSON.stringify(items.slice(0, 50)));

//         } catch (error) {
//             // Do nothing, this may happen in Safari in incognito mode
//         }


//     }

//     _removeFromFavorites(productId) {
//         var items = JSON.parse(localStorage.getItem('productFavorites') || '[]');

//         items = items.filter(c => c != productId);

//         try {
//             localStorage.setItem('productFavorites', JSON.stringify(items.slice(0, 50)));


//         } catch (error) {
//             console.log(error)
//         }

//         this._toggleFavorites();

//     }
//     _toggleFavorites() {

//         var items = JSON.parse(localStorage.getItem('productFavorites') || '[]');

//         $('.ProductItem__Favorites').each(function(index) {

//             let $this = $(this);
//             let myID = $this.attr('data-id');
//             if (items.includes(myID)) {
//                 $(".Icon--favorites-filled", $this).show();
//                 $(".Icon--favorites", $this).hide();
//                 if ($(".favorites--add", $this)) {
//                     $(".favorites--add", $this).hide();
//                     $(".favorites--added", $this).show();

//                 }
//             } else {
//                 $(".Icon--favorites-filled", $this).hide();
//                 $(".Icon--favorites", $this).show();
//                 if ($(".favorites--add", $this)) {
//                     $(".favorites--add", $this).show();
//                     $(".favorites--added", $this).hide();

//                 }
//             }

//         });

//     }

// }

// var favorites = new Favorites();